import { useRecoilValue } from 'recoil';
import type { PageConfig } from '@app/config';
import pageConfigRecoilState from '../state/pageConfig';

const usePageConfig = (): PageConfig | null =>
  useRecoilValue(pageConfigRecoilState);

export default usePageConfig;
